import { yupResolver } from '@hookform/resolvers/yup';
import { ITVRCVRFormMeta } from '@Modules/admin/archiving/containers/formHandlers/validTransactionInquiry/transactionHistory/tvrCVR/tvrCVRFormMeta';
import { CustomButton } from '@Modules/core/components';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: ITVRCVRFormMeta
} & TFormUIProps;

const TVR_CVRFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    
  } = useForm({ resolver: yupResolver(meta.schema) });

  const fields = getFormFieldsName(meta);
  const terminalVerificationResultsFields = fields.slice(0, 23);
  const cardVerificationResultsFields = fields.slice(23);

  console.log(cardVerificationResultsFields.slice(13));
  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CustomFieldSet title="Résultats Vérification Terminal">
        <CC.SimpleGrid
          columns={{ base: 1, "2xl": 2 }}
          gridRowGap={4}
          columnGap={24}
          my={4}
        >
          {displayCustomInputs(
            meta,
            register,
            errors,
            isLoading,
            terminalVerificationResultsFields
          )}
        </CC.SimpleGrid>
        
      </CustomFieldSet>

      <CustomFieldSet title="Résultats Vérification Carte">
        <CC.SimpleGrid
          columns={{ base: 1, "2xl": 2 }}
          gridRowGap={4}
          columnGap={24}
          my={4}
        >
          {displayCustomInputs(
            meta,
            register,
            errors,
            isLoading,
            cardVerificationResultsFields, cardVerificationResultsFields.slice(13)
          )}
        </CC.SimpleGrid>

        <CC.SimpleGrid
          columns={{ base: 1, "2xl": 2 }}
          gridRowGap={4}
          columnGap={24}
          my={4}
        >
          {displayCustomInputs(
            meta,
            register,
            errors,
            isLoading,
            cardVerificationResultsFields.slice(13)
          )}
        </CC.SimpleGrid>
        
      </CustomFieldSet>
      
      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default TVR_CVRFormUI;
